var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.672 17.74"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.336 0A6.348 6.348 0 000 6.336c0 2.489 1.5 5.219 2.956 7.4a39.811 39.811 0 002.656 3.5c.263.285.41.5.724.5s.46-.217.724-.5a39.811 39.811 0 002.656-3.5c1.453-2.18 2.956-4.91 2.956-7.4A6.348 6.348 0 006.336 0zm0 1.267a5.06 5.06 0 015.068 5.069c0 1.946-1.347 4.6-2.744 6.7-.623.93-1.619 2.172-2.324 3.067-.7-.895-1.7-2.137-2.324-3.067-1.4-2.1-2.744-4.752-2.744-6.7a5.06 5.06 0 015.068-5.065zm0 1.9a3.168 3.168 0 103.165 3.165 3.178 3.178 0 00-3.164-3.161zm0 1.267a1.9 1.9 0 11-1.9 1.9 1.887 1.887 0 011.901-1.896z",
    fill: "currentColor"
  })));
}

export default SvgPininline;